import { Bundle } from "@medplum/fhirtypes";
import { executeWithNetworkRetries } from "@metriport/shared";
import axios, { AxiosError } from "axios";
import { apiOSS as api } from "./apiOSS";

export async function getSearchResults(
  patientId: string,
  question: string
): Promise<Bundle | undefined> {
  const resp = await executeWithNetworkRetries(
    () =>
      api.get(`/medical/v1/patient/${patientId}/consolidated/search`, {
        params: { query: question },
      }),
    {
      httpCodesToRetry: [
        "ECONNRESET",
        "ECONNREFUSED",
        // cast to any is a workaround until new version of @metriport/shared supports this
        AxiosError.ERR_NETWORK as any, // eslint-disable-line @typescript-eslint/no-explicit-any
      ],
      maxAttempts: 3,
      initialDelay: 200,
    }
  );
  const url = resp.data?.url;
  if (!url) return undefined;

  const response = await axios.get(url);
  if (!response.data) return undefined;

  return response.data as Bundle;
}
